// extracted by mini-css-extract-plugin
module.exports = {"carouselWrap":"gallery_carouselWrap__mXj9o"};